const BOM_PARAMETERS_STORAGE_KEY = 'bomFormValues';

export type BOMParameters = {
  cuttingLoss: number;
  screwInserts: boolean;
  connectorToolAquacell160: boolean;
};

const defaultBOMFormValues: BOMParameters = {
  cuttingLoss: 10,
  screwInserts: true,
  connectorToolAquacell160: true,
};

export const getDefaultBOMParameters = (): BOMParameters => {
  const storedValues = sessionStorage.getItem(BOM_PARAMETERS_STORAGE_KEY);
  return storedValues ? JSON.parse(storedValues) : defaultBOMFormValues;
};

export const saveBOMParameters = (values: BOMParameters) => {
  sessionStorage.setItem(BOM_PARAMETERS_STORAGE_KEY, JSON.stringify(values));
};
